<template>
  <div class="cursor-container">
    <div class="cursor-element">
      <div class="cursor-motion">
        <svg>
          <circle
            r="80"
            cx="100"
            cy="100"
            fill="none"
            stroke-width="1px"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import cursor from '@/assets/animations/cursor';
import { isTouchDevice } from '@/scripts/utils';

export default {
  name: 'CursorContainer',

  data() {
    return { };
  },

  mounted() {
    if (!isTouchDevice()) {
      const circle = this.$el.querySelector('circle');
      circle.setAttribute('stroke-dasharray', circle.getTotalLength());
      circle.setAttribute('stroke-dashoffset', circle.getTotalLength());
      window.addEventListener('apollo-mouse-enter', event => this.cursorIn(event));
      window.addEventListener('apollo-mouse-leave', event => this.cursorOut(event));
    }
  },

  methods: {
    cursorIn(event) {
      cursor.get(`${event.detail.target.element.dataset.apolloHoverAnimation}-in`)(event.detail.target);
    },
    cursorOut(event) {
      cursor.get(`${event.detail.target.element.dataset.apolloHoverAnimation}-out`)(event.detail.target);
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-container {
  @extend %full-fixed;
  pointer-events: none;
  z-index: 100;

  @include mq($and: $is-touch-device) {
    display: none;
  }

  .cursor-element {
    position: absolute;
    width: 100px;
    height: 100px;
  }

  svg {
    width: 200px;
    height: 200px;
    margin-left: -48px;
    margin-top: -47px;
    overflow: visible;

    circle {
      stroke: $color-white;
      opacity: 0.3;

      @at-root .menu-open & {
        stroke: $color-gray;
      }

      @at-root .page-white & {
        stroke: $color-primary;
      }
    }
  }
}
</style>
